import { Routes } from '@angular/router';
import { ARRECADACAO_ROUTES } from '@/features/financeiro/arrecadacao/arrecadacao.constants';
import { permissionGuard } from '@/core/permissions/permission.guard';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

const { SERVICOS } = ARRECADACAO_ROUTES;
const P = PERMISSOES.arrecadacao;

export const arrecadacaoServicosRoutes: Routes = [
    {
        path: SERVICOS.ROOT,
        loadComponent: () => import('@/features/financeiro/arrecadacao/servicos/arrecadacao-servicos-content').then((m) => m.ArrecadacaoServicosContent),
        data: { breadcrumb: 'Serviços' },
        children: [
            { path: '', redirectTo: `/${ARRECADACAO_ROUTES.ROOT}`, pathMatch: 'full' },
            {
                path: 'pesquisar-boletos',
                loadComponent: () => import('@/features/financeiro/arrecadacao/servicos/pesquisar-boletos/pesquisar-boletos').then((m) => m.PesquisarBoletos),
                canActivate: [permissionGuard],
                data: { permission: P.pesquisarBoletos.escopo }
            },
            // Convidado: módulo `receita`, hospedado no menu da arrecadação. Gate pela role do dono.
            {
                path: 'consultar-receita',
                loadComponent: () => import('@/shared/components/consulta/consulta-receita/consulta-receita').then((m) => m.ConsultaReceita),
                canActivate: [permissionGuard],
                data: { permission: PERMISSOES.receita.consulta.visualizar }
            },
            {
                path: SERVICOS.GERAR_REMESSA,
                loadComponent: () => import('@/features/financeiro/arrecadacao/servicos/remessa/gerar-remessa/gerar-remessa').then((m) => m.GerarRemessa),
                canActivate: [permissionGuard],
                data: { breadcrumb: 'Gerar Remessa', permission: P.cobranca.escopo }
            },
            {
                path: SERVICOS.PROCESSAR_RETORNO,
                loadComponent: () => import('@/features/financeiro/arrecadacao/servicos/retorno/processar-retorno/processar-retorno').then((m) => m.ProcessarRetorno),
                canActivate: [permissionGuard],
                data: { breadcrumb: 'Processar Retorno', permission: P.cobranca.escopo }
            },
            {
                path: `${SERVICOS.PROCESSAR_RETORNO}/:jobId`,
                loadComponent: () => import('@/features/financeiro/arrecadacao/servicos/retorno/processar-retorno/processar-retorno').then((m) => m.ProcessarRetorno),
                canActivate: [permissionGuard],
                data: { permission: P.cobranca.escopo }
            },
            {
                path: SERVICOS.RETORNOS_PROCESSADOS,
                loadComponent: () => import('@/features/financeiro/arrecadacao/servicos/retorno/retornos-processados/retornos-processados').then((m) => m.RetornosProcessados),
                canActivate: [permissionGuard],
                data: { breadcrumb: 'Retornos Processados', permission: P.cobranca.escopo }
            },
            // Conciliação Bancária: sem role definida — ver Pendências da spec.
            { path: 'conciliacao-bancaria', loadComponent: () => import('@/features/financeiro/arrecadacao/servicos/conciliacao/conciliacao-bancaria/conciliacao-bancaria').then((m) => m.ConciliacaoBancaria) },
            {
                path: SERVICOS.EMAILS,
                loadComponent: () => import('@/features/financeiro/arrecadacao/servicos/emails-inadimplentes/emails-inadimplentes').then((m) => m.EmailsInadimplentes),
                canActivate: [permissionGuard],
                data: { breadcrumb: 'Emails para inadimplente', permission: P.emailsInadimplentes.escopo }
            }
        ]
    }
];
